import React, { useState } from "react";
import axios from "axios";


const useBib = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, values }) => { },
}) => {
    const [data, setData] = useState([])
    const [newBibData, setNewBibData] = useState([])
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck([])

    const getNewBibData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/koha/bib', {
            params: {
                field: "keyword",
                order: setOrders({
                    "bib_datecreated": "descend"
                }),
                size: 5,
                cur_page: 1,
                ...params
            },
        })
            .then((response) => {
                let data = response.data
                setNewBibData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success",
                            api: 'newBibData'
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error",
                            api: 'newBibData'
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const getBibData = (params) => {
        onBefore({ axiosMode: "get", values: params })
        return axios.get('/koha/bib', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                onFinish({ axiosMode: "get", status: data ? "success" : "error", values: data })

                return {
                    ...data
                }
            });
    }
    const postBibData = (data) => {
        onBefore({
            axiosMode: "post", values: data
        })
        axios.post('/koha/bib',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                onFinish({ axiosMode: "post", status: status === "success" ? "success" : "error", values: responseData })
            })
            .catch((ex) => {
                onFinish({ axiosMode: "post", status: "error", values: ex })
            })

    }
    const patchBibData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/koha/bib',
            data

        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteBibData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/koha/bib',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    const getBibInfoFormat = () => {
        let infoFormatData = [
            {
                language_name: "bib_title",
                valueKeys: ['bib_title'],
                isJoin: false
            },
            {
                language_name: "classification_number",
                valueKeys: ['bibitem_cn_class'],
                isJoin: false
            },
            {
                language_name: "author_number",
                valueKeys: ['bibitem_cn_item'],
                isJoin: false
            },
            {
                language_name: "import_bibliography_date",
                valueKeys: ['bib_datecreated'],
                isJoin: false
            },
            {
                language_name: "Author",
                valueKeys: ['bib_author'],
                isJoin: false
            },
            {
                language_name: "bib_translator",
                valueKeys: ['bib_translator'],
                isJoin: true
            },
            {
                language_name: "Material_type",
                valueKeys: ['bib_materialType'],
                isJoin: false
            },
            {
                language_name: "Language",
                valueKeys: ['bib_language'],
                isJoin: false
            },
            {
                language_name: "Series",
                valueKeys: ['bib_seriestitle', 'bibitem_volume'],
                isJoin: false
            },
            {
                language_name: "Publication_details",
                valueKeys: ['bib_publisher'],
                isJoin: false
            },
            {
                language_name: "Description",
                valueKeys: ['bib_notes'],
                isJoin: false
            },
            {
                language_name: "ISBN",
                valueKeys: ['bibitem_isbn'],
                isJoin: false
            },
            {
                language_name: "Edition",
                valueKeys: ['bibitem_editionstatement'],
                isJoin: false
            },
            {
                language_name: "Other_title",
                valueKeys: ['bib_othertitle'],
                isJoin: true
            },
            {
                language_name: "specification",
                valueKeys: ['bibitem_pages', 'bibitem_illus', 'bibitem_size'],
                isJoin: false
            },
            {
                language_name: "online_resources",
                valueKeys: ['bib_electronic_location','bib_electronic_location_name'],
                isJoin: false
            },
        ]
        return infoFormatData
    }
    return {
        BibData: data,
        newBibData,
        getBibData,
        getNewBibData,
        postBibData,
        patchBibData,
        deleteBibData,
        getBibInfoFormat
    }
}
export { useBib }



const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
